import { isEmpty } from 'lodash-es';
import type { AppConfigState } from './AppConfigProvider.types';

export function replaceLegacyPinNavigationSidebarConfig(appConfigState: AppConfigState) {
  const pinNavigationSidebar = appConfigState.pinNavigationSidebar ?? true;
  const pinNavigationSidebarSection = appConfigState.pinNavigationSidebarSection;

  // If the pinNavigationSidebarSection is empty, set the default values for the current navigation sections
  if (isEmpty(pinNavigationSidebarSection)) {
    appConfigState.pinNavigationSidebarSection = getDefaultPinnedSections(pinNavigationSidebar);
  }

  return appConfigState;
}

export function getDefaultPinnedSections(pinNavigationSidebar: boolean): Record<string, boolean> {
  return {
    trading: pinNavigationSidebar,
    transfers: pinNavigationSidebar,
    portfolio: pinNavigationSidebar,
    research: pinNavigationSidebar,
    operations: pinNavigationSidebar,
    dealer: pinNavigationSidebar,
    analytics: pinNavigationSidebar,
    monitoring: pinNavigationSidebar,
    admin: pinNavigationSidebar,
    'talos-admin': pinNavigationSidebar,
    settings: pinNavigationSidebar,
  };
}
